<template>
  <!-- 모르는 주소(router path '*')의 화면 — 흰 화면 대신(cpl-x1-unknownroute-1) · 템플릿 오류 화면 무늬(_error.scss) 그대로
       템플릿 images/error/404.png 는 «1015x473» 자리표 그림이라 안 씀(10-22 사진) -->
  <div class="container">
    <div class="row no-gutters height-self-center">
      <div class="col-sm-12 text-center align-self-center">
        <div class="iq-error position-relative">
          <h2 class="mb-0">찾는 화면이 없어요</h2>
          <p>주소가 바뀌었거나 없어진 화면이에요.</p>
          <button type="button" class="btn btn-primary mt-3" @click="goHome">홈으로</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NotFound',
  methods: {
    // 로그인 전이면 라우터 가드가 로그인 화면으로 보낸다
    goHome() {
      this.$router.push({ name: 'layout.dashboard1' })
    }
  }
}
</script>
